import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { MDBInput, MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import Store from './../../store'

import './SearchBar.component.scss'

const SearchBar = () => {
  const [localQuery, setLocalQuery] = useState('')
  const [debounceTimer, setDebounceTimer] = useState(null)

  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }
    }
  }, [debounceTimer])

  const handleInputChange = e => {
    const value = e.target.value
    setLocalQuery(value)

    // Debounce search
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    const timer = setTimeout(() => {
      Store.search(value)
    }, 300)

    setDebounceTimer(timer)
  }

  const handleClear = () => {
    setLocalQuery('')
    Store.clearSearch()
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }
  }

  const handleModeChange = mode => {
    Store.setSearchMode(mode)
  }

  return (
    <div id='SearchBarComponent' className='search-bar'>
      <div className='search-bar__input-wrapper'>
        <MDBInput
          label='Search manuals...'
          value={localQuery}
          onChange={handleInputChange}
          className='search-bar__input'
        />
        {localQuery && (
          <MDBBtn type='button' color='link' size='sm' onClick={handleClear} className='search-bar__clear'>
            <MDBIcon icon='times' />
          </MDBBtn>
        )}
      </div>
      <div className='search-bar__modes'>
        <button
          type='button'
          className={`search-bar__mode ${Store.searchMode === 'global' ? 'active' : ''}`}
          onClick={() => handleModeChange('global')}
        >
          All Manuals
        </button>
        <button
          type='button'
          className={`search-bar__mode ${Store.searchMode === 'current' ? 'active' : ''}`}
          onClick={() => handleModeChange('current')}
        >
          Current Document
        </button>
      </div>
      {Store.searchResults.length > 0 && (
        <div className='search-bar__results-count'>
          {Store.searchResults.length} result
          {Store.searchResults.length !== 1 ? 's' : ''} found
        </div>
      )}
    </div>
  )
}

export default observer(SearchBar)
